import { SuggestionObject } from "@/types/Shared/Search";

import {
  formatProductName,
  formatTitle,
  imagePath,
  shoppingImagePath,
  vehicleImagePath
} from "@/utils";
import {
  Flex,
  Link,
  Text,
  Image,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Button
} from "@chakra-ui/react";
import NextLink from "next/link";
import Router from "next/router";
import { Dispatch, SetStateAction } from "react";

interface SmartSearchListProps {
  Suggestions: SuggestionObject[];
  setSearch: Dispatch<SetStateAction<string>>;
  setDisclosureState: any;
}

export function SmartSearchListDesktop({
  Suggestions,
  setSearch,
  setDisclosureState
}: SmartSearchListProps) {
  const SizeSuggest = filterUniqByKey(Suggestions, "term") as SuggestionObject[];
  const ProdSuggest = filterUniqByKey(Suggestions, "productId") as SuggestionObject[];
  const VehiSuggest = filterUniqByKey(Suggestions, "term") as SuggestionObject[];

  // function topushed(target) {
  // console.log("foi", target);
  // Router.push(`/${target}`);
  // }

  function onylVeicle() {
    const prod = ProdSuggest.some((prod) => prod.typeTerm !== "Product");
    const size = ProdSuggest.some((prod) => prod.typeTerm !== "Size");
    const veicle = ProdSuggest.some((prod) => prod.typeTerm === "Vehicle");

    if (prod && size && veicle) {
      return true;
    } else {
      return false;
    }
  }

  return Suggestions?.length > 0 ? (
    <Flex w={"full"}>
      {/* PRODUCTS FADE */}
      {ProdSuggest?.some((i) => {
        if (i.typeTerm === "Product") {
          return true;
        }
      }) && (
        <Flex
          direction={"column"}
          w={"-webkit-fill-available"}
          maxH={"350px"}
          flex={1}
          hidden={
            !ProdSuggest?.some((i) => {
              if (i.typeTerm === "Product") {
                console.log(i);
                return true;
              }
            })
          }
        >
          <Text textStyle={"MSemi"}>PNEUS</Text>
          <Flex direction="column" overflowY="scroll" flex={2}>
            {ProdSuggest?.filter((s) => s.typeTerm === "Product")?.map((Sugg, Index) => {
              return (
                <>
                  <Link
                    key={Index}
                    py={"10px"}
                    w={"full"}
                    pr={"10px"}
                    display={"flex"}
                    alignItems={"center"}
                    href={`/pneu/${Sugg?.url}`}
                    // onClick={() => {
                    //   console.log("aqui");
                    //   setDisclosureState.off();
                    // }}
                    _focus={{ border: "none" }}
                    _hover={{ textDecoration: "none" }}
                  >
                    <Image
                      src={shoppingImagePath(Sugg.image)}
                      alt={Sugg.term}
                      onError={(e) =>
                        (e.currentTarget.src =
                          "https://cdn.pneufree.com.br/LINGLONG/images/Site/DefaultTire.jpg")
                      }
                      w={"80px"}
                      h={"80px"}
                    />

                    <Flex
                      w={"70%"}
                      direction={"column"}
                      color={"#444444"}
                      _hover={{
                        bgColor: "gray.200",
                        color: "black.900"
                      }}
                    >
                      <Text ml={"5px"} fontSize={"text1"} textStyle={"Bold"}>
                        {formatTitle(Sugg.term)}
                      </Text>
                      <Text ml={"5px"} fontSize={"text3"} color={"#3165C4"} textStyle={"Bold"}>
                        {formatProductName(Sugg.term)?.model}
                      </Text>
                    </Flex>
                  </Link>
                </>
              );
            })}
          </Flex>
        </Flex>
      )}
      {/* VEHICLES FADE */}

      {VehiSuggest?.some((i) => {
        if (onylVeicle()) {
          return true;
        }
      }) && (
        <Flex
          direction={"column"}
          w={"-webkit-fill-available"}
          flex={1}
          maxH={"350px"}
          overflowY={"scroll"}
          hidden={
            !VehiSuggest?.some((i) => {
              if (i.typeTerm === "Vehicle") {
                console.log(i);
                return true;
              }
            })
          }
        >
          <Text textStyle={"MSemi"}>VEÍCULOS</Text>
          <Flex direction="column" overflowY="scroll" flex={2}>
            {VehiSuggest?.filter((s) => s.typeTerm === "Vehicle")?.map((Sugg, Index) => {
              return (
                <>
                  {onylVeicle() && (
                    <Link
                      key={Index}
                      py={"10px"}
                      w={"full"}
                      display={"flex"}
                      // onClick={setDisclosureState.off}
                      onClick={() => Router.push(`/${Sugg?.urlb}`)}
                      // href={`/${Sugg?.urlb}`}
                      _focus={{ border: "none" }}
                      alignItems={"center"}
                      color={"#444444"}
                      _hover={{
                        textDecoration: "none",
                        bgColor: "gray.200",
                        color: "black.900"
                      }}
                    >
                      <Image
                        src={vehicleImagePath(Sugg?.image?.split(".")[0])}
                        onError={(e) =>
                          (e.currentTarget.src =
                            "https://cdn.pneufree.com.br/LINGLONG/images/Site/DefaultTire.jpg")
                        }
                        alt={Sugg?.term}
                        w="40px"
                        h="auto"
                      />
                      <Flex w="70%" direction="column" _hover={{ bgColor: "gray.200" }}>
                        <Text ml="5px" fontSize="text1" textStyle="Bold">
                          {Sugg.term}
                        </Text>
                      </Flex>
                    </Link>
                  )}
                </>
              );
            })}
          </Flex>
        </Flex>
      )}
      {/* SIZES FADE */}
      {SizeSuggest?.some((i) => {
        if (i.typeTerm === "Size") {
          return true;
        }
      }) && (
        <Flex
          hidden={
            !SizeSuggest?.some((i) => {
              if (i.typeTerm === "Size") {
                return true;
              }
            })
          }
          direction={"column"}
          maxH={"350px"}
          flex={1}
        >
          <Text textStyle={"MSemi"}>MEDIDAS</Text>
          <Flex direction="column" overflowY="scroll" flex={1} w={"-webkit-fill-available"}>
            {SizeSuggest?.map((Sugg, Index) => {
              return (
                <>
                  {Sugg.typeTerm === "Size" && (
                    <Link
                      key={Index}
                      py={"10px"}
                      px={"10px"}
                      fontSize={"text1"}
                      color={"#444444"}
                      textStyle={"Bold"}
                      // onClick={setDisclosureState.off}
                      href={"/" + Sugg.urlb}
                      _hover={{
                        color: "black.900",
                        bgColor: "gray.200"
                      }}
                      _focus={{ border: "none" }}
                    >
                      {Sugg.term}
                    </Link>
                  )}
                </>
              );
            })}
          </Flex>
        </Flex>
      )}
    </Flex>
  ) : (
    <Flex w={"full"} h={"200px"} justify={"center"} alignItems={"center"}>
      <Text textStyle={"MRegular"} fontSize={"text1"} color={"gray.500"}>
        Nenhum resultado para o termo solicitado!
      </Text>
    </Flex>
  );
}
export function SmartSearchListMobile({
  Suggestions,
  setSearch,
  setDisclosureState
}: SmartSearchListProps) {
  const SizeSuggest = filterUniqByKey(Suggestions, "term") as SuggestionObject[];
  const ProdSuggest = filterUniqByKey(Suggestions, "productId") as SuggestionObject[];
  const VehiSuggest = filterUniqByKey(Suggestions, "term") as SuggestionObject[];
  return Suggestions?.length > 0 ? (
    <Flex w="full" justifyContent="center">
      <Tabs w="340px">
        <TabList>
          {Suggestions?.some((i) => {
            if (i.typeTerm === "Product") {
              return true;
            }
          }) && <Tab>PNEUS</Tab>}
          {Suggestions?.some((i) => {
            if (i.typeTerm === "Size") {
              return true;
            }
          }) && <Tab>MEDIDAS</Tab>}
        </TabList>
        <TabPanels w="full" px={0} mx={0}>
          {ProdSuggest?.some((i) => {
            if (i.typeTerm === "Product") {
              return true;
            }
          }) && (
            <TabPanel maxH="300px" overflowY="scroll" id="ProductsTab">
              <Flex direction="column" flex={1}>
                {ProdSuggest?.filter((s) => s.typeTerm === "Product")?.map((Sugg, Index) => (
                  <Link
                    key={Index}
                    py="10px"
                    w="full"
                    zIndex={120}
                    onClick={(e) => {
                      setDisclosureState.off();
                    }}
                    href={`/pneu/${Sugg?.url}`}
                    _focus={{ border: "none" }}
                    _hover={{ textDecoration: "none" }}
                  >
                    <Flex alignItems="center">
                      <Image
                        src={shoppingImagePath(Sugg.image)}
                        alt={Sugg.term}
                        onError={(e) =>
                          (e.currentTarget.src =
                            "https://cdn.pneufree.com.br/LINGLONG/images/Site/DefaultTire.jpg")
                        }
                        w="80px"
                        h="80px"
                      />
                      <Flex w="70%" direction="column">
                        <Text ml="5px" fontSize="text1" textStyle="Regular">
                          {formatTitle(Sugg.term)}
                        </Text>
                        <Text ml="5px" fontSize="text1" color="blue.900" textStyle="MSemi">
                          {formatProductName(Sugg.term)?.model}
                        </Text>
                      </Flex>
                    </Flex>
                  </Link>
                ))}
              </Flex>
            </TabPanel>
          )}

          {SizeSuggest?.some((i) => {
            if (i.typeTerm === "Size") {
              return true;
            }
          }) && (
            <TabPanel maxH="300px" overflowY="scroll" id="SizesTab">
              <Flex direction="column" flex={1}>
                {SizeSuggest?.sort((a, b) => a.weight - b.weight)
                  ?.filter((s) => s.typeTerm === "Size")
                  ?.map((Sugg, Index) => (
                    <>
                      {console.log(Sugg?.urlb)}
                      <Link
                        key={Index}
                        zIndex={120}
                        py="10px"
                        px="10px"
                        fontSize="text1"
                        textStyle="MSemi"
                        onClick={setDisclosureState.off}
                        href={"/" + Sugg.urlb}
                        _hover={{
                          color: "blue.900",
                          bgColor: "gray.200"
                        }}
                        _focus={{ border: "none" }}
                      >
                        {Sugg.term}
                      </Link>
                    </>
                  ))}
              </Flex>
            </TabPanel>
          )}
          {VehiSuggest?.some((i) => {
            if (i.typeTerm === "Vehicle") {
              return true;
            }
          }) && (
            <TabPanel maxH="300px" overflowY="scroll" id="VehiclesTab">
              {/* {console.log("entrou aq no mobile", VehiSuggest)} */}
              <Flex direction="column" flex={1}>
                {VehiSuggest?.filter((s) => s.typeTerm === "Vehicle")?.map((Sugg, Index) => (
                  <Link
                    key={Index}
                    py="10px"
                    zIndex={120}
                    w="full"
                    onClick={setDisclosureState.off}
                    href={`/${Sugg?.urlb}`}
                    _focus={{ border: "none" }}
                    _hover={{ textDecoration: "none" }}
                  >
                    <Flex alignItems="center">
                      <Image
                        src={vehicleImagePath(Sugg?.image?.split(".")[0])}
                        alt={Sugg?.term}
                        w="18%"
                        h="auto"
                      />
                      <Flex w="70%" direction="column" _hover={{ bgColor: "gray.200" }}>
                        <Text ml="5px" fontSize="text3" color="blue.900" textStyle="MSemi">
                          {Sugg.term}
                        </Text>
                      </Flex>
                    </Flex>
                  </Link>
                ))}
              </Flex>
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </Flex>
  ) : (
    <Flex w="full" justify="center" alignItems="center">
      <Text textStyle="MRegular" fontSize="text1" color="gray.500" maxWidth="340px">
        Nenhum resultado para o termo solicitado!
      </Text>
    </Flex>
  );
}

export function filterUniqByKey(Arr: any, Key: string) {
  let ArrayOfUniquesByKey = [...new Map(Arr?.map((item) => [item?.[Key], item]))?.values()];
  return ArrayOfUniquesByKey;
}
